import { gql, useQuery } from '@apollo/client';

const gqlQueryFilter = gql`
    query overviewPricingTaxiState {
        CITRIN_MGT_overviewPricingTaxiState @client
    }
`;
const typeName = 'CITRIN_MGT_overviewPricingTaxiState';

export type OverviewState = {
    search?: string;
    selectedCities?: string[];
    page?: number;
};

const initialState: OverviewState = {
    search: '',
    selectedCities: [],
    page: 1,
};

export const useOverviewLinkState = (): [OverviewState, (newState: OverviewState) => void] => {
    const { data, client } = useQuery(gqlQueryFilter, { fetchPolicy: 'cache-first' });
    const setState = (newState: OverviewState) => {
        client.writeQuery({
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewPricingTaxiState: {
                    value: newState,
                    __typename: typeName,
                },
            },
        });
    };
    return [data?.CITRIN_MGT_overviewPricingTaxiState?.value ?? initialState, setState];
};

export default {
    defaults: [
        {
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewPricingTaxiState: {
                    value: initialState,
                    __typename: 'CITRIN_MGT_overviewPricingTaxiState',
                },
            },
        },
    ],
};
